<template>
  <div class="det-box main">
    <!-- 顶部栏 -->
    <div class="v_search">
      <el-row>
        <el-col :span="16">
          <div
            class="fl"
            style="display:flex;flex-direction:row;margin-right:10px;border-right:1px solid #f0f2f5;"
          >
            <div class="cursor-poiner" style="padding:0 15px;" @click="goVideoLeft">
              <el-image style="width:25px;height:25px;vertical-align:middle;" :src="src1"></el-image>
              <span style="vertical-align:middle;">成片库</span>
            </div>
            <div>
              <el-divider direction="vertical"></el-divider>
            </div>
            <div class="cursor-poiner" style="padding:0 15px;" @click="goVideoRight">
              <el-image style="width:25px;height:25px;vertical-align:middle;" :src="src2"></el-image>
              <span style="vertical-align:middle;">素材库</span>
            </div>
          </div>
          <div class="fl">
            <!-- <span> <i style="font-size:18px;" class="el-icon-files"></i></span> -->
            <el-select
              filterable
              allow-create
              default-first-option
              v-model="typeName"
              @change="selectTypeName"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.title"
                :value="item.title"
              ></el-option>
            </el-select>
          </div>
          <div class="fl">
            <i class="line"></i>
          </div>
          <div class="fl">
            <!-- <i class="el-icon-search"></i> -->
            <el-input
              v-model="searchValue"
              style="font-size:16px;"
              prefix-icon="el-icon-search"
              placeholder="名称/关键词/简介"
            ></el-input>
          </div>
        </el-col>
        <el-col class="tar" :span="8">
          <el-button
            style="padding:15px 30px;font-size:18px;background:#00aaff;color:#cfefff;"
            icon="el-icon-search"
            @click="integSearch"
          >综合检索</el-button>
          <router-link to="/videolist2?from=1">
            <el-button style="padding:15px 30px;font-size:16px;">高级检索</el-button>
          </router-link>
        </el-col>
      </el-row>
    </div>
    <!-- 视频简介 -->
    <div style="background:#fff;padding:15px;" class="clearfloat">
      <!-- 视频 -->
      <el-row style="height:360px;" class="clearfloat">
        <el-col :span="10">
          <div id="videoplayer" style="width:530px;height:357px;" class="d-v-left">
            <!-- <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
            ></video-player>-->
          </div>
        </el-col>

        <el-col style="border-bottom:1px dotted #555;" :offset="1" :span="13" class="bgc-white">
          <div class="box-right">
            <div class="v-r-text clearfloat">
              <div class="fl text-hidden" style="font-size:30px;font-weight:bold;line-height:40px;">
               <p :title="videoInfoDetail.fileName"> 名称： {{videoInfoDetail.fileName}}</p>
              </div>
            </div>
            <div style="padding:10px 0px" class="f20">
              <el-row class="mt-20">
                <el-col :span="12">
                  <span
                  :title="videoInfoDetail.activityName"
                    class="text-hidden-single"
                  >活动名称：{{videoInfoDetail.activityName || '暂无'}}</span>
                </el-col>
                <el-col :span="12">
                  <span
                  class="text-hidden-single"
                  :title="videoInfoDetail.orgName"
                  >主办单位：{{videoInfoDetail.orgName || ' 暂无' }} </span>
                </el-col>
              </el-row>
              <!-- <span
                v-if="videoInfoDetail.activityName"
              >&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;</span>-->
              <el-row class="mt-20">
                <el-col :span="12">
                  <span
                  :title="videoInfoDetail.activityTime "
                  class="text-hidden-single"
                  >活动时间：{{videoInfoDetail.activityTime || '暂无'}}</span>
                </el-col>
                <el-col :span="12">
                  <span class="text-hidden-single">活动地点：{{videoInfoDetail.address || ' 暂无'}}</span>
                </el-col>
              </el-row>
              <el-row class="mt-20">
                <el-col :span="12">
                  <div
                  :title="videoInfoDetail.personName"
                  class="text-hidden-single"
                  >相关人物：{{videoInfoDetail.personName || ' 暂无'}}</div>
                </el-col>
                <el-col :span="12">
                  <span :title="videoInfoDetail.collectUser" class="text-hidden-single">采集人：{{videoInfoDetail.collectUser || ' 暂无'}}</span>
                </el-col>
              </el-row>
              <el-row class="mt-20">
                <el-col :span="12">
                  <span :title="videoInfoDetail.collectTime" class="text-hidden-single">采集时间：{{videoInfoDetail.collectTime || ' 暂无'}}</span>
                </el-col>
                <el-col :span="12">
                  <span :title="videoInfoDetail.createTime" class="text-hidden-single">上传时间：{{videoInfoDetail.createTime || ' 暂无'}}</span>
                </el-col>
              </el-row>
            </div>
            <!--  <div v-if="videoInfoDetail.personName" class="f18">相关人物：{{videoInfoDetail.personName}}</div>
            <div class="f18">
              <span
                v-if="videoInfoDetail.collectUser"
              >采集人：{{videoInfoDetail.collectUser}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <br/>
              <span
                v-if="videoInfoDetail.collectTime"
              >采集时间：{{videoInfoDetail.collectTime}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <br/>
              <span
                v-if="videoInfoDetail.createUser"
              >上传人：{{videoInfoDetail.createUser}} &nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span v-if="videoInfoDetail.createTime">上传时间：{{videoInfoDetail.createTime}}</span>
            </div>-->
            <div class="f20" style="padding:10px 0px">
              <el-row>
                <el-col :span="12">
                  <span :title="videoInfoDetail.viewcount" class="text-hidden-single">浏览次数：{{videoInfoDetail.viewcount || '0'}}</span>
                </el-col>
                <el-col :span="12">
                  <span :title="videoInfoDetail.downloads" class="text-hidden-single">下载次数：{{videoInfoDetail.downloads || '0'}}</span>
                </el-col>
              </el-row>
              <!--  <span
                v-if="videoInfoDetail.viewcount"
              >浏览次数：{{videoInfoDetail.viewcount}} &nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span>下载次数：{{videoInfoDetail.downloads || '0'}}</span>-->
            </div>
          </div>
          <!-- <div style="border-bottom:1px dotted #555;"></div> -->
          <!--  <div class="box-right box-right-upload-btn">
            <div class="f14 clearfloat">

              <div class="vd_collect fl">
                <el-rate style="font-size:30px!important;" class="tar"  disabled @change="isCollect" :max="number" v-model="value"></el-rate>
                <el-button type="primary" @click="collectionVideoInfos" >{{collectName}}</el-button>
              </div>
              <el-button @click="dowloadVideo" class="fr"  type="primary">立即下载</el-button>
            </div>
          </div>-->
        </el-col>
      </el-row>
      <div style="width:50%" class="fr box-right box-right-upload-btn">
        <div class="clearfloat">
          <div class="vd_collect fl">
            <el-rate
              style="font-size:30px!important;"
              class="tar"
              disabled
              @change="isCollect"
              :max="number"
              v-model="value"
            ></el-rate>
            <el-button type="primary" @click="collectionVideoInfos">{{collectName}}</el-button>
          </div>
          <!-- <el-button v-if="roleId == 1" @click="dowloadVideo" class="fr" type="primary">立即下载</el-button> -->
        </div>
      </div>
      <!-- 简介 -标签 -->
      <el-row class="" style="margin-top:80px">
        <div class="d-intro-tag padding-20 bgc-white">
          <p
            class="f20"
            style="padding:0px 0px 20px 0px; "
          >简介：{{videoInfoDetail.fileIntro || '暂无简介'}}</p>
          <div>
            <div class="f20">标签：</div>
            <div style="padding:10px 20px;font-size:20px">
              <div>
                <el-tag v-for="(item,index) in videoInfoDetail.videoOldTags" :key="index">{{item}}</el-tag>
              </div>

              <!-- {{videoInfoDetail.videoOldTags || '暂无' }}(原系统标签) -->
              <br />
              <div>
                <el-tag v-for="(item,index) in videoInfoDetail.videoNewTags" :key="index" type="success">{{item}}</el-tag>
              </div>
              <!-- {{videoInfoDetail.videoNewTags || '暂无' }} -->
            </div>
          </div>
        </div>
      </el-row>
    </div>

    <!-- 分享 -->
    <el-row v-if="roleId != 6" class style="border-top:1px solid #e9e9e9;">
      <div class="tar padding-20 bgc-white">
        <!--<share :config="conf"></share>-->
        <span>分享到</span>
        <el-button @click="shareweb(0)" icon="iconfont iconqq" circle></el-button>
        <el-button @click="shareweb(1)" icon="iconfont iconQQkongjian" circle></el-button>
        <el-button @click="shareweb(2)" icon="iconfont iconweibo" circle></el-button>
        <span>&nbsp;</span>
        <el-popover trigger="click" placement="top" width="300">
          <div class="offBox">
            <h4>微信里点“发现”，扫一下二维码。便可将本文分享至朋友圈。</h4>
            <div>
              <canvas id="ewmpic"></canvas>
            </div>
          </div>
          <el-button @click="shareweb(3)" slot="reference" icon="iconfont iconweixin" circle></el-button>
        </el-popover>
      </div>
    </el-row>
    <!-- 视频集 --如果没有视频集合则没有此功能-->
    <!-- • 如果单视频没有名称、简介、单位、活动等内容，则使用视频集的信息显示。
         • 上面显示单视频的信息，下面显示视频集合的信息。
    • 无视频集的单视频，不显示此视频集区域内容。-->

    <div v-if="status == 1" class="mt" style="background:#fff;">
      <h5 class="de-title" style="padding:30px;border-bottom:1px solid #e9e9e9;">视频集</h5>
      <div class="bgc-white padding-20 f14">
        <el-row>
          <!-- <span>名称：</span> -->
          <span
            style="font-size:22px;font-weight:bold;padding:30px 0px;display:inline-block;"
          >{{collectionVideoInfo.title}}</span>
          <span class="f18 fr">
            共
            <span style="color:red;font-size:20px">{{collectionVideoInfo.videoCount}}个</span> 视频
          </span>
        </el-row>
        <el-row>
          <span class="txt-color1">活动：</span>
          <span>{{collectionVideoInfo.activityName}} /</span>
          <span class="txt-color1">主办单位：</span>
          <span>{{collectionVideoInfo.orgName}} /</span>
          <span class="txt-color1">活动时间：</span>
          <span>{{collectionVideoInfo.createTime}} /</span>
          <span class="txt-color1">活动地点：</span>
          <span>{{collectionVideoInfo.activityAddress}}</span>
        </el-row>
        <el-row style="padding:20px 0px;">
          <span class="txt-color1">相关人物：</span>
          <span>{{collectionVideoInfo.personName}}</span>
        </el-row>
        <el-row>
          <div>
            <span class="txt-color1">采集人：</span>
            <span>{{collectionVideoInfo.collectUser}}</span>
          </div>
          <div>
            <span class="txt-color1">采集时间：</span>
            <span>{{collectionVideoInfo.collectTime}}</span>
          </div>
          <div>
            <span class="txt-color1">上传人：</span>
            <span>{{collectionVideoInfo.createUser}}</span>
          </div>
          <div>
            <span class="txt-color1">上传时间：</span>
            <span>{{collectionVideoInfo.createTime}}</span>
          </div>
        </el-row>

        <el-row>
          <p>
            <span class="txt-color1">简介：</span>
            {{collectionVideoInfo.intro}}
          </p>
        </el-row>
        <el-row>
          <span class="txt-color1">标签：</span>
          <br/>
          <div style="padding:10px 20px 0px 20px;">
              <el-tag v-for="(item,index) in collectionVideoInfo.videoOldTags" :key="index">{{item}}</el-tag>
          </div>
          <br />
         <div style="padding:0px 20px;">
            <el-tag v-for="(item,index) in collectionVideoInfo.videoNewTags" type="success" :key="index">{{item}}</el-tag>
          </div>
          <!-- <div class="ml">{{collectionVideoInfo.videoOldTags || '暂无'}} (原系统标签)</div>

          <div class="ml">{{collectionVideoInfo.videoNewTags || '暂无'}}</div> -->
        </el-row>
      </div>
      <div>
        <ImgList v-on:activeId="selectActive" :parentList="videoList"></ImgList>
      </div>
    </div>
    <div class="v-d-line"></div>
    <!-- 视频管理功能，只有管理员可见 -->
    <el-row v-if="isAdmin" class="mt vd_manage">
      <el-col class="tal" :span="6">视频管理功能</el-col>
      <el-col class="tar" :span="18">
        <span>
          <el-button
            v-if="status == 1"
            @click="editColleVideoInfo"
            type="primary"
            size="mini"
          >编辑视频集信息</el-button>
        </span>
        <!-- <span>
          <el-button @click="isVisibleTag = true" type="info" size="mini">编辑标签</el-button>
        </span>-->
        <span>
          <el-button type="primary" size="mini" @click="editSingleVideo">编辑视频信息</el-button>
        </span>
        <span>
          <el-button
            size="mini"
            v-if="videoInfoDetail.isElite == 'Y'"
            @click="recoVideoInfo"
          >已推荐,点击取消</el-button>
          <el-button size="mini" v-else type="success" @click="recoVideoInfo">推荐该视频</el-button>
        </span>
        <span>
          <el-popover v-model="isOpen" trigger="click" placement="top" width="300">
            <div class="offBox">
              <h4>下线理由：</h4>
              <div>
                <el-input type="textarea" v-model="reason" rows="6"></el-input>
              </div>
              <el-button type="success" @click="offLineVideoInfo">提交</el-button>
            </div>
            <el-button
              v-if="videoInfoDetail.status == '1'"
              slot="reference"
              size="mini"
              @click="offLineVideo"
            >下线本视频/集</el-button>
            <el-button
              size="mini"
              v-else
              slot="reference"
              disabled
              @click="offLineVideo"
              type="danger"
            >已下线</el-button>
          </el-popover>
        </span>
      </el-col>
    </el-row>
    <!-- 单视频编辑框 -->
    <div class="editform">
      <el-dialog :title="editTitle" :visible.sync="dialogVisible">
        <div class="form-box">
          <el-form label-width="180px">
            <el-form-item label="视频名称：">
              <el-input
                style="width:80%;"
                v-if="isClick"
                v-model="editVideoInfo.fileName"
                placeholder="请输入单视频名称"
              ></el-input>
              <el-input
                style="width:80%;"
                v-else
                v-model="editVideoInfo.title"
                placeholder="请输入视频集名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="视频分类：">
              <el-select
                placeholder="请输入视频分类"
                style="width:80%;"
                v-model="editVideoInfo.contentType"
              >
                <el-option
                  v-for="item in styleDoorList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="视频门类：">
              <el-select
                placeholder="请输入视频门类"
                style="width:80%;"
                filterable
                allow-create
                default-first-option
                v-model="editVideoInfo.category"
                @change="selectTypeName"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.title"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="活动名称：">
              <el-input style="width:80%;" placeholder="请输入活动名称" v-model="editVideoInfo.activityName"></el-input>
            </el-form-item>
            <el-form-item label="活动时间：">
              <el-date-picker
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width:80%;"
                placeholder="请选择日期"
                v-model="editVideoInfo.activityTime"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="活动地点：">
              <!-- <el-cascader
                style="width:80%;"
                @change="handleChangeAddress"
                v-model="editAddress"
                clearable
                :props="{ checkStrictly: true,label:'label',value:'label' }"
                :options="addressJson"
              ></el-cascader>-->
              <el-input
                style="width:80%;"
                v-if="isClickVideo == 0"
                placeholder="请输入活动地点"
                v-model="editVideoInfo.address"
              ></el-input>
              <el-input
                v-if="isClickVideo == 1"
                placeholder="请输入活动地点"
                v-model="editVideoInfo.activityAddress"
              ></el-input>
            </el-form-item>
            <el-form-item label="主办单位：">
              <!-- <el-cascader
                v-model="orgName"
                style="width:80%;"
                @change="selectOrg"
                :options="organizationList"
                :props="{multiple: false,value:'title'}"
              ></el-cascader>-->
              <el-input style="width:80%;" placeholder="请输入主办单位" v-model="editVideoInfo.orgName"></el-input>
            </el-form-item>
            <el-form-item class="cc" label="相关人物：">
              <!-- 可多选 -->
              <el-select
                style="width:80%;"
                @change="checkPersonName"
                filterable
                allow-create
                multiple
                v-model="personName"
              >
                <el-option
                  v-for="item in videoPerson"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="简介：">
              <el-input
                style="width:80%;"
                v-if="isClick"
                v-model="editVideoInfo.fileIntro"
                rows="3"
                type="textarea"
                placeholder="请输入简介"
              ></el-input>
              <el-input
                v-else
                style="width:80%;"
                v-model="editVideoInfo.intro"
                rows="3"
                type="textarea"
                placeholder="请输入简介"
              ></el-input>
            </el-form-item>
          <!--   <el-form-item label="标签：">
              <div>
                <el-tag :key="tag" v-for="tag in OldTags">{{tag}}</el-tag>
              </div>
              <el-tag
                :key="tag"
                v-for="tag in newTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
              >{{tag}}</el-tag>

              <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              ></el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加</el-button>
            </el-form-item> -->
            <el-form-item  style="position:relative;" label="标签：">
              <el-input  @keyup.enter.native="changeInputTags"  @blur="changeInputTags" style="width:80%" v-model="inputTags" >

              </el-input>
             <!--  <el-input v-if="inputTags" style="width:80%;">

              </el-input> -->
               <br/>

               <span class="f12">提示：标签用中文符号 ； 隔开</span>
               <div>
                <el-tag :key="tag" v-for="tag in OldTags">{{tag}}</el-tag>
              </div>
              <div id="tagIpt" style="width:80%">
                <span v-for="(item,index) in inputNewArrShow"  :key="index" class="el-tag el-tag--light">
                  {{item}}<i class="el-tag__close el-icon-close" @click="handleClose(item)"></i>
                </span>
              </div>

              <!-- <div id="tagIpt" style="position:absolute;top:0px;left:10px;"></div> -->
            </el-form-item>
            <el-form-item label="封面图片：">
              <div class="edmitImg">
                <el-upload
                  class="avatar-uploader"
                  action="/api/v1/advertise/uploadImgs"
                  :show-file-list="false"
                  name="imgFiles"
                  :headers="headers"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitEdit">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 标签编辑框 -->
    <!-- <div class="editTag">
      <el-dialog title="编辑标签" :visible.sync="isVisibleTag">

      </el-dialog>
    </div>-->
  </div>
</template>

<script>
// async function loadedHandler() {
//   console.log(window)
//   await window.init();
//   player = window.init()
//   player.addListener("play", loadedMetaDataHandler);
//   // this.player.addListenerInside('click',this.loadedMetaDataHandler())
// }
// function loadedMetaDataHandler() {
//   var metaData = player.getMetaDate();
//   console.log("监听视频状态：", metaData);
// }
import axios from 'axios'
import map from '../../../../static/json/district.json'
import QRCode from 'qrcode'
import ImgList from '../videolist/videolist'
// import '../../../../static/ckplayer/ckplayer.js'
var oDownLoad = null
export default {
  components: {
    ImgList
  },
  data: function () {
    return {
      roleId:'',
      inputTags: '',
      inputNewArr: [],
      inputNewArrShow: [],
      category: '', // 门类
      typeName2: '', // 分类
      styleDoorList: [
        {
          id: 0,
          name: '新闻类',
          label: 'NEWS'
        },
        {
          id: 1,
          name: '直播类',
          label: 'LIVE'
        },
        {
          id: 2,
          name: '访谈类',
          label: 'VIEW'
        },
        {
          id: 3,
          name: '作品类',
          label: 'WORKS'
        },
        {
          id: 4,
          name: '其他类',
          label: 'OTHER'
        }
      ], // 门类
      isPaused: Boolean,
      player: {},
      isOpen: false,
      //
      isAdmin: false, // 是否是管理员
      // 封面图
      imageUrl: '',
      // 搜索
      typeName: '', // 下拉框
      searchValue: '', // 搜索框
      typeList: [],
      src1: require('../../../assets/img/icon/video.png'),
      src2: require('../../../assets/img/icon/sucai.png'),
      number: 1,
      value: null, // 分值
      collectName: '收藏本视频',
      activeId: 0, // 点击的视频的索引
      isElite: Boolean, // 视频是否是被推荐
      reason: '', // 下线理由
      // ---ckplayer
      videoPoster: '', // 封面图
      video: {
        file: '',
        type: 'video/mp4'
      },
      videoSrc: [],
      // playerOptions: {
      //   playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
      //   autoplay: false, //如果true,浏览器准备好时开始回放。
      //   muted: false, // 默认情况下将会消除任何音频。
      //   loop: false, // 导致视频一结束就重新开始。
      //   preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      //   language: "zh-CN",
      //   aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      //   fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      //   sources: [
      //     {
      //       type: "video/mp4",
      //       src: "" //url地址
      //     }
      //   ],
      //   poster: "", //你的封面地址
      //   // width: document.documentElement.clientWidth,
      //   notSupportedMessage: "", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      //   controlBar: {
      //     timeDivider: true,
      //     durationDisplay: true,
      //     remainingTimeDisplay: false,
      //     fullscreenToggle: true //全屏按钮
      //   }
      // }, // 视频配置
      videoInfoDetail: {}, // 视频详细信息
      editVideoInfo: {}, // 修改视频详细信息，回显
      videoList: [], // 视频集列表
      status: this.$route.query.status, // 单视频还是视频集
      collectionVideoInfo: {}, // 视频集信息
      dialogVisible: false, // 编辑视频信息弹框
      addressJson: map, // 地点数组
      editAddress: [], // 选择的地点数组
      //
      personName: [],
      editTitle: '视频信息编辑',
      isClick: Boolean, // 点击的是编辑视频还是视频集，true为视频，false为视频集
      // isVisibleTag: false,
      videoPerson: [],
      organizationList: [], // 机构列表
      // 标签修改
      inputVisible: false,
      inputValue: '',
      OldTags: [],
      newTags: [],
      orgName: [],
      isClickVideo: -1, // 0点击编辑单视频 1点击视频集
      videoObject: {
        container: '#videoplayer', // 容器的ID或className
        variable: 'player', // 播放函数名称
        loaded: 'loadedHandler', // 当播放器加载后执行的函数
        loop: false, // 播放结束是否循环播放
        cktrack: '', // 字幕文件
        poster:
          'https://gong-xiang-ban-quan-tu-pian.oss-cn-beijing.aliyuncs.com/copyright/20190807/yt_path/9971ded625ec4aaf9e32aea6ee6f18b9.jpg', // 封面图片
        preview: {
          // 预览图片
          file: ['', ''],
          scale: 2
        },
        mobileCkControls: false, // 是否在移动端（包括ios）环境中显示控制
        config: '', // 指定配置函数
        debug: false, // 是否开启调试模式
        drag: 'start', // 拖动的属性
        seek: 0, // 默认跳转的时间
        // 广告部分开始
        // adfront:
        //   "http://×××w.ckplayer.com/yytf/swf/front001.swf,http://×××w.ckplayer.com/yytf/swf/front002.swf", //前置广告
        // adfronttime: "15,15",
        // adfrontlink: "",
        // adpause:
        //   "http://×××w.ckplayer.com/yytf/swf/pause001.swf,http://×××w.ckplayer.com/yytf/swf/pause002.swf",
        // adpausetime: "5,5",
        // adpauselink: "",
        // adinsert:
        //   "http://×××w.ckplayer.com/yytf/swf/insert001.swf,http://×××w.ckplayer.com/yytf/swf/insert002.swf",
        // adinserttime: "10,10",
        // adinsertlink: "",
        // inserttime: "10,80",
        // adend:
        //   "http://×××w.ckplayer.com/yytf/swf/end001.swf,http://×××w.ckplayer.com/yytf/swf/end002.swf",
        // adendtime: "15,15",
        // adendlink: "",
        // 广告部分结束
        promptSpot: [
          // 提示点
          // {
          //   words: "提示点文字01",
          //   time: 30
          // },
          // {
          //   words: "提示点文字02",
          //   time: 150
          // }
        ],
        // video: {
        //   file: "",
        //   type: "video/mp4"
        // }
        video: []
        // video: [
        //   [
        //     "http://img.ksbbs.com/asset/Mon_1703/05cacb4e02f9d9e.mp4",
        //     "video/mp4",
        //     "中文标清",
        //     0
        //   ],
        //   [
        //     "http://img.ksbbs.com/asset/Mon_1703/d0897b4e9ddd9a5.mp4",
        //     "video/mp4",
        //     "中文高清",
        //     10
        //   ],
        // [
        //   "http://img.ksbbs.com/asset/Mon_1703/eb048d7839442d0.mp4",
        //   "video/mp4",
        //   "英文高清",
        //   0
        // ],
        // [
        //   "http://img.ksbbs.com/asset/Mon_1703/d30e02a5626c066.mp4",
        //   "video/mp4",
        //   "英文超清",
        //   0
        // ]
        // ]
      }

      /* conf:{
        url:window.location.href,
        source:'光明网',
        title:'',
        description:'',
        image:'',
        sites   : ['qzone', 'qq', 'weibo','wechat'],
      /!*  disabled: ['google', 'facebook', 'twitter'], // 禁用的站点*!/
        wechatQrcodeTitle   : '微信扫一扫：分享', // 微信二维码提示文字
        wechatQrcodeHelper  : '<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>'
      } */
    }
  },
  computed: {
    headers: function () {
      return {
        token: window.localStorage.getItem('token')
      }
    }
  },
  methods: {
    showTags (data) {
      data = data.split('；')
      var html = ''
      for (var i = 0; i < data.length; i++) {
        html += `<span class="el-tag el-tag--light" >` + data[i] + `</span>`

        // html += `<span class="el-tag el-tag--light" >` + this.inputNewArr[i] + `<i class="el-tag__close el-icon-close" @click="closeNewArr(` + i + `)"></i></span>`
        document.getElementById('tagIpt').innerHTML = html
      }
    },
    changeInputTags () {
      this.inputNewArrShow = this.inputTags.split('；')
     
    },
    // 去除空数组
    threeData: function (data) {
      // console.log(data);
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length === 0) {
          data[i].children = null
        } else {
          this.threeData(data[i].children)
        }
      }
      return data
    },
    // 选择主办单位
    // selectOrg: function() {
    //   console.log(this.orgName);
    //   this.editVideoInfo.orgName = this.orgName.join(",");
    // },
    // 成片库
    goVideoLeft: function () {
      this.$router.push({
        path: '/videolist2',
        query: {
          from: 1,
          videoTypeId: 1
        }
      })
    },
    // 素材库
    goVideoRight: function () {
      this.$router.push({
        path: '/videolist2',
        query: {
          from: 1,
          videoTypeId: 0
        }
      })
    },
    // 综合检索
    integSearch: function () {
      if (this.typeName == '' && this.searchValue == '') {
        this.$message.info('请选择搜索条件')
      } else {
        this.$router.push({
          path: '/videolist2',
          query: {
            from: true,
            typeName: this.typeName,
            retrieval: this.searchValue
          }
        })
      }
    },
    // 下载
    dowloadVideo: async function () {
      // var res = await this.$http.get('http://image.wangrui8.top/dms-2019-07-22-00-00~1.mp4',{
      //   responseType: "blob",
      // })
      if (window.localStorage.getItem('token')) {
        let blobUrl = `http://10.1.212.181/api/v1/videoDownload/videoDownloadById?vid=${this.videoInfoDetail.id}`
        let link = document.createElement('a')
        link.target = '_blank'
        document.body.appendChild(link)
        link.href = blobUrl
        // link.download = "下载文件.mp4";
        link.click()
        // window.URL.revokeObjectURL(blobUrl);
      } else {
        this.$message.error('未登录，即将跳转到登录页面！')
        setTimeout(() => {
          this.$router.push('/login')
        }, 1500)
      }

      // --------

      // axios({
      //   url: `/v1/videoDownload/videoDownloadById?vid=C01`,
      //   method: "get",
      //   responseType: "blob",
      //   onDownloadProgress(progress) {
      //     // 这里是下载的进度
      //     console.log(
      //       Math.round((progress.loaded / progress.total) * 100) + "%"
      //     );
      //   }
      // }).then(res => {
      //   let blobUrl = window.URL.createObjectURL(res.data);
      //   let link = document.createElement("a");
      //   document.body.appendChild(link);
      //   link.href = blobUrl;
      //   // link.download = "下载文件.mp4";
      //   link.click();
      //   window.URL.revokeObjectURL(blobUrl);
      // });

      // var res = await this.$http.get(
      //   `/v1/videoDownload/videoDownloadById?vid=C01`
      // );
      // var { code, message, data } = res.data;
      // if (code == 0) {
      //   alert(data);
      //   console.log("ddddd", data);
      // }
    },
    // 修改封面图
    handleAvatarSuccess (res, file) {
      if (res.code == 0) {
        this.imageUrl = URL.createObjectURL(file.raw)
        this.editVideoInfo.imgUrl = res.data
        this.editVideoInfo.fileLocation = res.data
      } else if (res.code == 40100) {
        this.$message.error(res.message)
        this.$router.push('/login')
      } else {
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },

    // 获取文艺类视频的二级分类
    getTypeList: async function () {
      var res = await this.$http.get('/v1/index/videoTypeList')
      var { code, data } = res.data
      if (code == 0) {
        this.typeList = data

        // console.log(this.typeList);
      }
    },
    // 【顶部搜索条】
    selectTypeName: function () {
      // console.log(this.typeName);
    },
    // 编辑标签
    handleClose (tag) {
      this.newTags.splice(this.newTags.indexOf(tag), 1)
      this.inputNewArrShow.splice(this.inputNewArrShow.indexOf(tag), 1)
      this.inputTags = this.inputNewArrShow.join('；')
    },
    closeNewArr (index) {
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.newTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // ---ckplayer 初始化、
    init: function () {
      var that = this
      this.videoObject.poster = that.videoPoster
      
      this.videoObject.video = this.videoInfoDetail.videoTypeGroup
      // 定义一个对象
      // var player = new ckplayer(this.videoObject);
      this.player = new ckplayer(this.videoObject)
      this.loadedHandler()
    },
    loadedHandler: function () {
      // this.player.addListener("play", this.loadedMetaDataHandler());

      // this.player.addListener('play',this.loadedMetaDataHandler());

      // this.player.addListenerInside('click',this.loadedMetaDataHandler())
      this.$nextTick(() => {
        document.getElementById('videoplayer').addEventListener('click', () => {
          var metaData = this.player.getMetaDate()
          // console.log('监听视频状态：', metaData)
          this.isPaused = metaData.paused
          if (metaData.paused) {
            // 暂停状态
          } else {
            // 播放状态
            this.addPlay()
          }
        })
      })
    },
    // loadedMetaDataHandler: function() {
    //   var metaData = this.player.getMetaDate();
    //   console.log("监听视频状态：", metaData);
    // },
    addPlay: async function () {
      var res = await this.$http.post(
        `/v1/videoInfo/addplaycount?id=${this.$route.query.id}`
      )
      var { code, data, message } = res.data
      if (code == 0) {
        // console.log('播放量加一')
      } else {
        // console.log(message)
      }
    },
    // 清除播放
    clearPlay: function () {
      this.player.videoClear()
    },
    //, ---
    //   接受子组件传递过来的数据
    selectActive: function (val) {
      this.activeId = val
    },
    // 是否是收藏
    isCollect: function () {
      // console.log(this.value);
    },
    // 判断收藏状态
    videoCollectstatus: async function () {
      var res = await this.$http.get(
        `/v1/collect/videoCollectStatus?id=${this.videoInfoDetail.id}`
      )
      var { code, data } = res.data
      if (code == 0) {
        this.collectStatus = data
        if (this.collectStatus == 'Y') {
          this.value = 1
          this.collectName = '取消收藏'
        } else {
          this.value = 0
          this.collectName = '收藏本视频'
        }
      }
    },
    // 收藏本视频
    collectionVideoInfos: async function (id) {
      var res = await this.$http.post(
        `/v1/collect/collectionVideoInfo?id=${this.videoInfoDetail.id}`
      )
      var { code, message, data } = res.data
      if (code == 0) {

        if (this.value == 1) {
          this.$message.success('已取消')
          this.value = 0
          this.collectName = '收藏本视频'
        } else {
          this.value = 1
          this.collectName = '取消收藏'
          this.$message.success('收藏成功！')
        }
      } else if (code == 40100) {
        this.$message.error(message + ', 即将跳转到登录页！')
        setTimeout(() => {
          this.$router.push('/login')
        }, 2000)
      } else {
        this.$message.error(message)
      }
    },
    // 获取视频列表
    getVideoList: async function (callback) {
      var id = this.$route.query.id
      // 单视频
      var res = await this.$http.get(`/v1/videoInfo/videoInfoDetails?id=${id}`)
      var { code, message, data } = res.data
      if (code == 0) {
        this.videoInfoDetail = data
        // this.editVideoInfo = JSON.parse(JSON.stringify(data))
        if (data.address) {
          this.editAddress = data.address.split(' ')
        }
        if (data.videoNewTags !== null) {
          this.videoInfoDetail.videoNewTags = data.videoNewTags.split(',')
        }
        if (data.videoOldTags !== null && data.videoOldTags !== '') {
          this.videoInfoDetail.videoOldTags = data.videoOldTags.split(',')
        }
        this.isElite = data.isElite == 'Y'

        this.videoPoster = data.fileLocation
        this.video.file = data.filePath

        if (window.localStorage.getItem('token')) {
          this.videoCollectstatus()
        }
      } else {
        this.$message.error(message)
      }
      setTimeout(() => {
        callback()
      }, 200)
    },
    getVideoCollList: async function (callback) {
      // 获取视频集的信息
      var id = this.$route.query.id
      var res = await this.$http.get(`/v1/videoInfo/groupInfoDetails?id=${id}`)
      var { code, message, data } = res.data
      if (code == 0) {
        this.collectionVideoInfo = data
        this.videoInfoDetail = data.videoInfoList[0]
        if (this.videoInfoDetail.address) {
          this.editAddress = this.videoInfoDetail.address.split(' ')
        }
        if (data.videoInfoList[0].videoNewTags !== null) {
          this.videoInfoDetail.videoNewTags = data.videoInfoList[0].videoNewTags.split(',')
        }
        if (data.videoInfoList[0].videoOldTags !== null) {
          this.videoInfoDetail.videoOldTags = data.videoInfoList[0].videoOldTags.split(',')
        }
        if (data.videoNewTags !== null) {
          this.collectionVideoInfo.videoNewTags = data.videoNewTags.split(',')
        }
        if (data.videoOldTags !== null && data.videoOldTags !== '') {
          this.collectionVideoInfo.videoOldTags = data.videoOldTags.split(',')
        }
        // this.editVideoInfo = JSON.parse(JSON.stringify(data.videoInfoList[0]))
        this.isElite = data.videoInfoList[0].isElite == 'Y'
        this.videoList = data.videoInfoList
        // this.playerOptions.sources[0].src = data.videoInfoList[0].filePath;
        // this.playerOptions.poster = data.videoInfoList[0].fileLocation;
        this.videoPoster = data.videoInfoList[0].fileLocation
        this.video.file = data.videoInfoList[0].filePath
        // console.log('视频封面图', this.videoPoster)
        if (window.localStorage.getItem('token')) {
          this.videoCollectstatus()
        }
      } else {
        this.$message.error(message)
      }
      setTimeout(() => {
        callback()
      }, 200)
    },
    isVideoCollection: function () {
      var status = this.$route.query.status
      if (status == 0) {
        this.getVideoList(this.init)
      } else {
        this.getVideoCollList(this.init)
      }
    },
    // 【视频管理功能-仅管理员可见】
    // 推荐视频
    getEliteStatus: async function () {
      await this.isVideoCollection()
      if (this.videoInfoDetail.isElite == 'Y') {
        this.$message.error('取消推荐成功！')
      } else {
        this.$message.success('推荐成功！')
      }
    },
    recoVideoInfo: function () {
      this.$confirm('是否推荐或取消推荐该视频？', '提示', {
        confrimButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        var res = await this.$http.post(
          `/v1/videoInfo/editVideoInfo?id=${this.videoInfoDetail.id}`
        )
        var { code, message, data } = res.data
        if (code == 0) {
          this.getEliteStatus()
        } else if (code == 40100) {
          this.$router.push('/login')
        } else {
          this.$message.error(message)
        }
      })
    },
    // 下线/上线视频
    offLineVideo: function () {},
    offLineVideoInfo: async function () {
      let type = this.$route.query.status
      var reason = this.reason
      var res = await this.$http.post(
        `/v1/videoInfo/offLineVideoInfo?id=${this.$route.query.id}&reason=${this.reason}&type=${type}`
      )
      var { code, message, data } = res.data
      if (code == 0) {
        this.$message.success('下线成功')
        this.isOpen = false
        this.isVideoCollection()
      } else if (code == 40101) {
        this.$router.push('/login')
      } else {
        this.$message.error(message)
      }
    },
    // 编辑视频信息
    // 选择相关人物
    checkPersonName: function () {
      this.editVideoInfo.personName = this.personName
      this.editVideoInfo.personName = this.editVideoInfo.personName.join(',')
    },
    editColleVideoInfo: function () {
      this.isClickVideo = 1
      this.isClick = false
      this.dialogVisible = true
      this.editVideoInfo = JSON.parse(JSON.stringify(this.collectionVideoInfo))
      // var oldTags = this.editVideoInfo.videoOldTags.split(",");
      if (this.editVideoInfo.imgUrl) {
        this.imageUrl = this.editVideoInfo.imgUrl
      } else {
        this.imageUrl = ''
      }

      if (this.editVideoInfo.videoNewTags) {
        this.inputNewArrShow = this.editVideoInfo.videoNewTags
        this.editVideoInfo.videoNewTags = this.inputTags = this.editVideoInfo.videoNewTags.join('；')
      } else {
        this.newTags = []
        this.inputNewArrShow = []
      }
      if (this.editVideoInfo.videoOldTags !== null && this.editVideoInfo.videoOldTags !== '') {
        this.OldTags = this.editVideoInfo.videoOldTags.split(',')
      } else {
        this.OldTags = []
      }
      if (this.editVideoInfo.personName) {
        this.personName = this.editVideoInfo.personName.split(',')
      } else {
        this.personName = []
      }
      this.editTitle = '视频集信息编辑'
    },
    editSingleVideo: function () {
      this.isClickVideo = 0
      this.isClick = true
      this.dialogVisible = true
      this.editVideoInfo = JSON.parse(JSON.stringify(this.videoInfoDetail))
      // console.log('单视频/////////', this.editVideoInfo)
      if (this.editVideoInfo.fileLocation) {
        this.imageUrl = this.editVideoInfo.fileLocation
      } else {
        this.imageUrl = ''
      }
      if (this.editVideoInfo.videoNewTags) {
        this.inputNewArrShow = this.editVideoInfo.videoNewTags
        this.editVideoInfo.videoNewTags = this.editVideoInfo.videoNewTags.join('；')
        this.inputTags = this.editVideoInfo.videoNewTags
        // console.log('tagg//////', this.editVideoInfo.videoNewTags, this.inputTags)
      } else {
        this.newTags = []
        this.inputNewArrShow = []
      }

      if (this.editVideoInfo.videoOldTags !== null && this.editVideoInfo.videoOldTags !== '') {
        this.OldTags = this.editVideoInfo.videoOldTags.split(',')
      } else {
        this.OldTags = []
      }

      if (this.editVideoInfo.personName) {
        this.personName = this.editVideoInfo.personName.split(',')
      } else {
        this.personName = []
      }

      this.editTitle = '视频信息编辑'
    },
    handleChangeAddress: function () {
      this.editVideoInfo.address = this.editAddress.join('')
      // console.log(this.editVideoInfo.address)
    },
    // 单视频修改提交
    singleSubmit: async function () {
      this.editVideoInfo.videoOldTags = null
      var res = await this.$http.post(
        '/v1/videoInfo/saveVideoInfo',
        this.editVideoInfo
      )
      var { data, message, code } = res.data
      if (code == 0) {
        this.$message.success('更新成功')

        this.isVideoCollection()
        this.dialogVisible = false
      } else {
        this.$message.error(message)
      }
    },
    collectSubmit: async function () {
      this.editVideoInfo.videoOldTags = null
      this.editVideoInfo.videoInfoList = null
      var res = await this.$http.post(
        '/v1/videoInfo/saveGroupInfo',
        this.editVideoInfo
      )
      var { data, message, code } = res.data
      if (code == 0) {
        this.$message.success('更新成功')
        this.isVideoCollection()
        this.dialogVisible = false
      } else if (code == 40100) {
        this.$message.error('未登录，请先登录！')
        this.$router.push('/login')
      } else {
        this.$message.error(message)
      }
    },

    submitEdit: function () {
      if (this.isClick == true) {
        this.singleSubmit()
      } else {
        this.collectSubmit()
      }
    },
    // 相关人物列表
    getVideoPersonList: async function () {
      var res = await this.$http.get(`/v1/index/videoPersonList`)
      var { code, message, data } = res.data
      if (code == 0) {
        this.videoPerson = data
      }
    },
    // 机构列表
    getOrganizationList: async function () {
      var res = await this.$http.get(`/v1/index/organizationList`)
      var { code, data, message } = res.data
      if (code == 0) {
        this.organizationList = this.threeData(data)
      }
    },
    // 分享到QQ
    shareweb: function (res) {
      var url = window.location.href
      url = encodeURIComponent(url || document.location)
      var title = this.videoInfoDetail.fileName
      if (title == null) {
        title = '暂无视频名称'
      }
      var describe = this.videoInfoDetail.fileIntro //
      if (describe == null) {
        describe = '暂无视频介绍'
      }
      var pic = this.videoInfoDetail.fileLocation
      var summary = this.videoInfoDetail.fileIntro //
      var qq =
        'http://connect.qq.com/widget/shareqq/index.html?url=' +
        url +
        '&title=' +
        title +
        '&desc=' +
        describe +
        '&summary=' +
        summary +
        '&site=光明网&pics=' +
        pic
      var qzone =
        'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' +
        url +
        '&title=' +
        title +
        '&desc=' +
        describe +
        '&summary=' +
        summary +
        '&site=光明网&pics=' +
        pic
      var weibo =
        'http://service.weibo.com/share/share.php?url=' +
        url +
        '&sharesource=weibo&title=' +
        title +
        '&pic=' +
        pic +
        '&appkey='
      if (res == 0) {
        var elink = document.createElement('a')
        elink.target = '_blank'
        elink.style.display = 'none'
        elink.href = qq
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
        var res = this.$http.post(
          `/v1/videoInfo/addshare?id=${this.videoInfoDetail.id}`
        )
      }
      if (res == 1) {
        var elink = document.createElement('a')
        elink.target = '_blank'
        elink.style.display = 'none'
        elink.href = qzone
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)

        var res = this.$http.post(
          `/v1/videoInfo/addshare?id=${this.videoInfoDetail.id}`
        )
      }
      if (res == 2) {
        var elink = document.createElement('a')
        elink.target = '_blank'
        elink.style.display = 'none'
        elink.href = weibo
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)

        var res = this.$http.post(
          `/v1/videoInfo/addshare?id=${this.videoInfoDetail.id}`
        )
      }

      if (res == 3) {
        var msg = document.getElementById('ewmpic')
        // 将获取到的数据（val）画到msg（canvas）上
        var resret = window.location.href
        QRCode.toCanvas(msg, resret, function (error) {
          // console.log(error)
        })

        var res = this.$http.post(
          `/v1/videoInfo/addshare?id=${this.videoInfoDetail.id}`
        )
      }
    },
    forBidden () {
      // 去除页面按空格键下移
      document.body.onkeydown = function (event) {
        var keycode = event.keyCode || event.which
        // var e = window.event || event
        switch (keycode) {
          case 32:
            window.event.returnValue = false
            break
        }
        // if (e.preventDefault) {
        //   e.preventDefault()
        // } else {
        //   window.event.returnValue = false
        // }
      }
    },
    // 监听回退键函数
    goBack: function () {
      this.$store.state.isBack = true
      this.$router.go(-1)
    }
  },

  mounted: function () {
   
    this.getVideoPersonList()
    this.getOrganizationList()
    this.isVideoCollection()
    this.getTypeList()
    this.isAdmin = this.$store.state.userInfo.roleid == 1
    document.querySelector('#app').scrollIntoView(true)
    window.init = this.init
    // this.forBidden()
    // 监听回退键
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
      this.roleId =this.$store.state.userInfo.roleid
  },
  destroyed () {
    // 销毁回退监听
    window.removeEventListener('popstate', this.goBack, false)
  },
  watch: {
    videoInfoDetail: {
      handler: function (newValue, oldValue) {
        // this.clearPlay()
        // if (oldValue == true) {
        //   this.$confirm("退出后，修改信息将不会保存，确定退出吗？", "提示", {
        //     confrimButtonText: "确定",
        //     cancelButtonText: "取消"
        //   })
        //     .then(() => {
        //       this.$message.info("退出");
        //     })
        //     .catch(() => {
        //       this.$message.info("取消退出");
        //     });
        // }
      },
      deep: true
    },
    inputTags: function () {
      this.editVideoInfo.videoNewTags = this.inputTags.replace(/；/g, ',')
    },
    newTags: function () {
      // this.editVideoInfo.videoNewTags = this.newTags.join(',')
    },
    '$route.query.id': function () {
      this.isVideoCollection()
      document.querySelector('#app').scrollIntoView(true)
    },
    player: function () {
      this.clearPlay()
    },
    dialogVisible: function () {
      if (this.dialogVisible) {
        // console.log('哈哈哈哈哈', this.player.V.paused)
        if (this.player.V.paused === false) {
          this.player.playOrPause()
        }
        this.player.V = null
        this.clearPlay()
        document.body.onkeydown = function (event) {
          var keycode = event.keyCode || event.which
          // var e = window.event || event
          switch (keycode) {
            case 32:
              window.event.returnValue = true
              break
          }
        }
      } else {
        this.init()
        document.body.onkeydown = function (event) {
          var keycode = event.keyCode || event.which
          // var e = window.event || event
          switch (keycode) {
            case 32:
              window.event.returnValue = false
              break
          }
        }
      }
    }
  },
  beforeDestroy: function () {
    this.clearPlay()
    this.player.V = null
  },
  beforeRouteLeave (to, from, next) {
    // console.log(to.path)
    if (to.path == '/videolist2') {
      this.$store.state.isModeStatus = this.$route.query.status
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
.det-box {
  .el-row {
    // margin-top: 20px;
    .el-col {
      height: 100%;
      //   background-color: #fff;
    }
    // &:first-child {
    //   height: 281px;
    // }
  }
  .box-right {
    padding: 0px 0px 20px 20px;
  }
  .box-right-upload-btn {
    padding: 20px;
  }
  .v-r-text {
    //   padding: 20px;
    height: 30px;
    line-height: 30px;
  }
}
.vd_collect {
  display: flex;
  flex-direction: row;
  .el-rate {
    // height: 30px;
    .el-rate__item  {
      .el-rate__icon{
        font-size: 41px !important;

      }
    }
  }
}
.d-intro-tag {
  min-height: 200px;
}
.de-title {
  color: #0099ff;
  font-size: 20px;
}
// 顶部搜索栏
// 搜索框
.v_search {
  position: relative;
  z-index: 3;
  width: 1200px;
  height: 86px;
  line-height: 86px;
  background-color: #fff;
  margin: 0 auto;
  margin-bottom: 20px;
  padding: 0 30px;
  .el-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .left_btn {
    cursor: pointer;
    color: #fff;
    border-radius: 13px;
    padding: 10px;
    text-align: center;
    .tt {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .line {
    display: inline-block;
    width: 1px;
    height: 39px;
    background-color: #ccc;
    margin: 0 20px;
    vertical-align: middle;
  }
}
// 虚线
.v-d-line {
  border-bottom: 2px dotted #ccc;
  margin-top: 30px;
}
// 视频管理功能
.vd_manage {
  width: 100%;
  height: 80px;
  // color: #fff;
  // background-color: rgba(157, 187, 204, 1);
  background-color: #fff;
  border-radius: 6px;
  line-height: 80px;
  padding: 0 20px;
}
// 下线理由弹出框
.offBox {
  min-height: 250px;
  .el-textarea {
    padding: 30px 10px;
  }
}
// 视频编辑弹窗

.form-box {
  border-bottom: 1px solid #ccc;
}
</style>
<style lang="scss">
/* // 视频按钮样式 */
// .d-v-left .video-js .vjs-big-play-button {
//   width: 100px !important;
//   height: 100px !important;
//   border-radius: 50%;
// }
// .d-v-left .vjs-custom-skin > .video-js .vjs-big-play-button {
//   width: 60px !important;
//   height: 60px !important;
//   line-height: 60px !important;
// }
// .d-v-left .video-js .vjs-control-text {
//   position: absolute;
//   left: 0px;
//   top: 20px;
// }
// .d-v-left .video-js:hover .vjs-big-play-button,
// .vjs-custom-skin > .video-js .vjs-big-play-button:focus,
// .vjs-custom-skin > .video-js .vjs-big-play-button:active {
//   background-color: #555;
//   /* // background-color: #fff; */
// }
/* 视频编辑弹窗 */
.editform .el-dialog__header {
  background-color: #0099ff;
}
.editform .el-dialog__header .el-dialog__title,
.editform .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
/* 多选下拉框 */
// .editform .el-select__tags {
//   left: 265px !important;
//   min-width: 600px !important;
// }
// .editform .cc .el-input__suffix {
//   right: -45px;
//   top: 0px;
// }
// .editform .cc .el-select .el-input .el-select__caret {
//   font-size: 25px;
//   border: 1px solid #ccc;
//   &:hover {
//     cursor: pointer;
//   }
// }
// .editform .el-select__input {
//   position: absolute;
//   left: -250px;
//   width: 200px !important;
//   max-width: 200px !important;
// }
//修改封面
.edmitImg {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
<style lang="scss">
  .el-rate {
    // height: 30px;
    .el-rate__item  {
      .el-rate__icon{
        font-size: 41px !important;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/videotype/videodetail.vue